import { CSSProperties, useEffect } from "react";
import { factoryRuntimeSettings, useFactoryRuntimeSettings } from "@/core/stores/factory-runtime-settings.store";

export const companyBrandName = process.env.REACT_APP_BRAND_NAME?.trim();

interface CompanyBrandProps {
  variant: "login" | "header";
  logoStyle?: CSSProperties;
}

/** The supplied company logo for builds that opt in to Procons branding. */
export default function CompanyBrand({ variant, logoStyle }: CompanyBrandProps) {
  useFactoryRuntimeSettings();
  const brandName = factoryRuntimeSettings.string("brandName", companyBrandName);
  useEffect(() => {
    if (!companyBrandName) return;

    const iconPath = `${process.env.PUBLIC_URL || ""}/resources/brand/procons-logo.png`;
    document.querySelectorAll<HTMLLinkElement>('link[rel="icon"], link[rel="apple-touch-icon"]').forEach(link => {
      link.href = iconPath;
      link.type = "image/png";
    });
    const description = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (description) description.content = `Hệ thống quản lý kinh doanh ${brandName}`;
  }, [brandName]);

  if (!companyBrandName) {
    return <img src="/resources/brand/logo.png" alt={brandName || "Nhà máy nước"} style={logoStyle} />;
  }

  return <img src={`${process.env.PUBLIC_URL || ""}/resources/brand/procons-logo.png`} alt={brandName || companyBrandName}
    width={variant === "login" ? 320 : 180} height={variant === "login" ? 107 : 60}
    style={{ display: "block", width: variant === "login" ? 320 : 180, height: "auto", maxWidth: "100%",
      objectFit: "contain", margin: variant === "login" ? "0 auto" : undefined }} />;
}
